
import {
  boxShadow,
} from "assets/jss/material-dashboard-pro-react.jsx";

export default {
  photo: {
    transition: "all 300ms linear",
    width: "34px",
    height: "34px",
    overflow: "hidden",
    float: "left",
    zIndex: "5",
    marginRight: "11px",
    borderRadius: "50%",
    marginLeft: "23px",
    ...boxShadow
  },
  avatarImg: {
    width: "100%",
    verticalAlign: "middle",
    border: "0"
  },
}



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/views/userAvatar.jsx